import { Stack, Typography, useTheme } from "@mui/material";
import type { ReactNode } from "react";
import { ValueNotProvided } from "web_myplann/Shared/Components/ValueNotProvided";
import { moneyFormatter } from "web_myplann/Shared/Utils/formatters";

type ListItemMoneyValueProps = {
	value: string | number | null | undefined;
	currencySign: string;
	adornment?: ReactNode;
};

const isValueUnknown = (value: string | number | null | undefined) =>
	value === null || value === undefined || value === "";

export const ListItemMoneyValue = ({
	value,
	currencySign,
	adornment,
}: ListItemMoneyValueProps) => {
	const theme = useTheme();
	const color = theme.palette.grey[500];

	if (isValueUnknown(value)) {
		return <ValueNotProvided color={color} />;
	}

	return (
		<Stack direction="row" gap={0.8}>
			<Typography fontSize={14} fontWeight={400} color={color}>
				{moneyFormatter(value, currencySign)}
			</Typography>
			{adornment}
		</Stack>
	);
};
